import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  icons: {
    actionableIcon: {
      backgroundColor,
      borderColor,
      color,
      disabledColor,
      hoverBackgroundColor,
      hoverColor,
    },
  },
}: ComposedTheme) => ({
  actionableIcon: {
    backgroundColor,
    border: '1px solid transparent',
    display: 'flex',
    padding: 8,

    '&:active, &:focus': {
      outline: 'none',
      borderColor,
      borderRadius: 32,
    },

    '&:hover:not([disabled])': {
      border: `1px solid ${hoverBackgroundColor}`,
      background: hoverBackgroundColor,
      borderRadius: 32,

      '& svg': { fill: hoverColor },
    },

    '&:not([disabled]) svg': { fill: color },
    '&[disabled] svg': { fill: disabledColor },
  },
});

export default createUseStyles(styles);
